import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { processReq } from "../../helpers/processRequest";
import { GET, POST, PUT } from "../../utils/requestActionConstants";
import { API_ROUTE } from "../../utils/commonConstants";

const init = {
    ticket: {},
    ticketList: [],
    loading: {},
    error: null
};

export const ticketSlice = createSlice({
    name: "ticketSlice",
    initialState: init,
    reducers: {
        setTicket: (state, action) => {
            state.ticket = action.payload;
        },

        setTickets: (state, action) => {
            state.ticketList = action.payload;
        },

        clearData: (state) => {
            return init;
        },
    },
    extraReducers: (builder) => {
        builder
        // Fetch data list
        .addCase(fetchTicketList.pending, (state) => {
            state.loading.fetching = true;
            state.error = null;
        })
        .addCase(fetchTicketList.fulfilled, (state, action) => {
            state.loading.fetching = false;
            state.ticketList = action.payload;
        })
        .addCase(fetchTicketList.rejected, (state, action) => {
            state.loading.fetching = false;
            state.error = action.payload;
        })

        // Add ticket
        .addCase(addTicket.pending, (state) => {
            state.loading.saving = true;
            state.error = null;
        })
        .addCase(addTicket.fulfilled, (state, action) => {
            state.loading.saving = false;
            state.ticket = action.payload;
        })
        .addCase(addTicket.rejected, (state, action) => {
            state.loading.saving = false;
            state.error = action.payload;
        })

        // Update ticket
        .addCase(updateTicket.pending, (state) => {
            state.loading.saving = true;
            state.error = null;
        })
        .addCase(updateTicket.fulfilled, (state, action) => {
            state.loading.saving = false;
            state.ticket = action.payload;
        })
        .addCase(updateTicket.rejected, (state, action) => {
            state.loading.saving = false;
            state.error = action.payload;
        });;
    }
});

export const fetchTicketList = createAsyncThunk(
    "productSlice/fetchTicketList",
    async (_, { rejectWithValue }) => {
        try {
            const response = await processReq(GET, `${API_ROUTE}/tickets`);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || "Failed to fetch data");
        }
    }
);

export const updateTicket = createAsyncThunk(
    "ticketSlice/updateTicket",
    async ({ ticketId, ticketData }, { rejectWithValue, dispatch }) => {
        try {
            const response = await processReq(PUT, `${API_ROUTE}/tickets/${ticketId}`, ticketData);
            dispatch(fetchTicketList());
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || "Failed to update ticket");
        }
    }
);

export const addTicket = createAsyncThunk(
    "ticketSlice/addTicket",
    async ({ ticketData }, { rejectWithValue, dispatch }) => {
        try {
            const response = await processReq(POST, `${API_ROUTE}/tickets`, ticketData);
            dispatch(fetchTicketList());
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || "Failed to add ticket");
        }
    }
);

export const { clearData, setTicket, setTickets } = ticketSlice.actions;

export default ticketSlice.reducer;
